import React, { Component } from 'react';
import loader from '../../assets/pictos/loader.svg';
import styles from './styles';
import { css } from 'aphrodite';

class Loader extends Component {
    render() {
        // const { imgUrl } = this.props;

        return(
            <div className={css(styles.loaderWrapper)}>
                <img className={css(styles.loader)} src={'/themes/custom/aew/simulator/' + loader} alt="Loading"/>
            </div>
        );
    }
}

export default Loader;
